import type { ViewerProvider } from './types';
import { OHIFViewerProvider } from './providers/OHIFViewerProvider';
import { OHIF312ViewerProvider } from './providers/OHIF312ViewerProvider';
import { GWTViewerProvider } from './providers/GWTViewerProvider';

const viewerRegistry = new Map<string, ViewerProvider>();

export function registerViewer(provider: ViewerProvider): void {
  viewerRegistry.set(provider.id, provider);
}

export function getViewer(id: string): ViewerProvider | undefined {
  return viewerRegistry.get(id);
}

export function getDefaultViewer(): ViewerProvider {
  return viewerRegistry.get('ohif')!;
}

export function getAllViewers(): ViewerProvider[] {
  return Array.from(viewerRegistry.values());
}

// Register viewers at module load
registerViewer(OHIFViewerProvider);
registerViewer(OHIF312ViewerProvider);
registerViewer(GWTViewerProvider);
